import { StyledCheckbox } from "../../styles/StyledCheckbox/StyledCheckbox";
import { PropTypes } from "prop-types";
// import { useState } from "react";

export default function Checkbox({ changeHandler, value, name }) {
	return (
		<StyledCheckbox>
			<span onClick={changeHandler} className={value ? "checked" : ""}></span>
			<input type="checkbox" name={name} id={name} value={value} onChange={changeHandler} />
		</StyledCheckbox>
	);
}

Checkbox.propTypes = {
	// isChecked: PropTypes.bool,
	changeHandler: PropTypes.func,
	value: PropTypes.bool,
	name: PropTypes.string,
};
